import {
  Dashboard,
  Person,
  PowerOff,
  School,
  Contacts,
  VerifiedUser,
  AttachMoney,
  MenuBook,
  EventNote,
  Inventory2,
  Assessment,
  Palette,
  Language,
  Security,
  History,
  Help,
  PeopleAlt,
} from "@mui/icons-material";

export enum PageName {
  auth = "auth",
  logout = "logout",
  dashboard = "dashboard",
  settings = "settings",
  profile = "profile",
  institute = "institute",
  spocPremise = "spocPremise",
  compliance = "compliance",
  feeStructure = "feeStructure",
  academics = "academics",
  lessonPlan = "lessonPlan",
  material = "material",
  assessment = "assessment",
  branding = "branding",
  localization = "localization",
  rbac = "rbac",
  auditTrail = "auditTrail",
  help = "help",
  users = "users",
}

export const getAuthPageDetails = () => ({
  [PageName.auth]: {
    path: "/",
    aliasPath: "/login",
    title: "Login",
  },
  [PageName.logout]: {
    path: "/",
    aliasPath: "/logout",
    title: "Logout",
    icon: <PowerOff />,
  },
});

export const getDashBoardPageDetails = () => ({
  [PageName.dashboard]: {
    path: "/" + PageName.dashboard,
    title: "Dashboard",
    icon: <Dashboard />,
    subPages: {},
  },
});

export const getProfilePageDetails = () => ({
  [PageName.profile]: {
    path: "/" + PageName.profile,
    title: "Profile",
    icon: <Person />,
  },
});

export const getInstitutePageDetails = () => ({
  [PageName.institute]: {
    path: "/" + PageName.institute,
    title: "Institute",
    icon: <School />,
  },
});

export const getSpocPremisePageDetails = () => ({
  [PageName.spocPremise]: {
    path: "/" + PageName.spocPremise,
    title: "SPOC & Premise",
    icon: <Contacts />,
  },
});

export const getCompliancePageDetails = () => ({
  [PageName.compliance]: {
    path: "/" + PageName.compliance,
    title: "Compliance",
    icon: <VerifiedUser />,
  },
});

export const getFeeStructurePageDetails = () => ({
  [PageName.feeStructure]: {
    path: "/" + PageName.feeStructure,
    title: "Fee Structure",
    icon: <AttachMoney />,
  },
});

export const getAcademicsPageDetails = () => ({
  [PageName.academics]: {
    path: "/" + PageName.academics,
    title: "Academics",
    icon: <MenuBook />,
  },
});

export const getLessonPlanPageDetails = () => ({
  [PageName.lessonPlan]: {
    path: "/" + PageName.lessonPlan,
    title: "Lesson Plans",
    icon: <EventNote />,
  },
});

export const getMaterialPageDetails = () => ({
  [PageName.material]: {
    path: "/" + PageName.material,
    title: "Materials",
    icon: <Inventory2 />,
  },
});

export const getAssessmentPageDetails = () => ({
  [PageName.assessment]: {
    path: "/" + PageName.assessment,
    title: "Assessment",
    icon: <Assessment />,
  },
});

export const getBrandingPageDetails = () => ({
  [PageName.branding]: {
    path: "/" + PageName.branding,
    title: "Branding",
    icon: <Palette />,
  },
});

export const getLocalizationPageDetails = () => ({
  [PageName.localization]: {
    path: "/" + PageName.localization,
    title: "Localization",
    icon: <Language />,
  },
});

export const getRbacPageDetails = () => ({
  [PageName.rbac]: {
    path: "/" + PageName.rbac,
    title: "Roles",
    icon: <Security />,
  },
});

export const getAuditTrailPageDetails = () => ({
  [PageName.auditTrail]: {
    path: "/" + PageName.auditTrail,
    title: "Audit Trail",
    icon: <History />,
  },
});

export const getHelpPageDetails = () => ({
  [PageName.help]: {
    path: "/" + PageName.help,
    title: "Help & Documentation",
    icon: <Help />,
  },
});

export const getUsersPageDetails = () => ({
  [PageName.users]: {
    path: "/" + PageName.users,
    title: "User Management",
    icon: <PeopleAlt />,
  },
});
